"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import SSRIcon from "@ingka/ssr-icon";
import cx from "classnames";
import warningTriangle from "@ingka/ssr-icon/paths/warning-triangle";
const inverseTypes = [
  "primary",
  "emphasised",
  "secondary",
  "tertiary"
];
const Button = forwardRef(
  (props, ref) => {
    const {
      href = "",
      newWindow = false,
      loadingSrText = "Loading\u2026",
      ssrIcon,
      iconOnly = false,
      prefix = "",
      htmlType = "button",
      disabled = false,
      className = "",
      onClick,
      text = "",
      type = "secondary",
      expanding = false,
      loading = false,
      iconPosition = "leading",
      fluid = false,
      inverseTheme = false,
      children,
      expandedOnTouchDevice = false,
      size = "medium",
      ...others
    } = props;
    const onKeyUpHandler = (e) => {
      if (disabled || loading || e.key !== " ") {
        return;
      }
      const target = e.target;
      target.click();
    };
    let btnType = type ? type : "secondary";
    if (iconOnly && ssrIcon) {
      btnType = `icon-${btnType}`;
    }
    if (inverseTheme && type !== "danger" && type !== "plain" && type !== "image-overlay" && inverseTypes.indexOf(type) > -1) {
      btnType = `${btnType}-inverse`;
    }
    const innerClasses = cx(`${prefix}btn__inner`);
    const iconClass = `${prefix}btn__icon`;
    const icon = type === "danger" ? warningTriangle : ssrIcon;
    const iconTag = icon ? /* @__PURE__ */ jsx(SSRIcon, { className: iconClass, prefix, paths: icon }) : null;
    const classes = cx(
      `${prefix}btn`,
      loading && `${prefix}btn--loading`,
      size !== "medium" && `${prefix}btn--${size}`,
      !iconOnly && icon && iconPosition && `${prefix}${iconPosition}-icon`,
      type && `${prefix}btn--${btnType}`,
      fluid && !iconOnly && `${prefix}btn--fluid`,
      expanding && `${prefix}btn--expanding`,
      expanding && expandedOnTouchDevice && `${prefix}btn--touch-device-expanded`,
      className
    );
    const handleClick = (ev) => {
      if (loading || disabled) {
        ev.stopPropagation();
        return;
      }
      if (onClick && typeof onClick === "function")
        onClick(ev);
    };
    const buttonContent = /* @__PURE__ */ jsxs("span", { className: innerClasses, children: [
      iconTag,
      text && /* @__PURE__ */ jsx("span", { className: `${prefix}btn__label`, children: text }) || null,
      !loading && children || null,
      loading && /* @__PURE__ */ jsx("span", { className: `${prefix}btn__loader`, children: loadingSrText }) || null
    ] });
    if (href) {
      return /* @__PURE__ */ jsx(
        "a",
        {
          ref,
          className: classes,
          "aria-disabled": loading ? true : void 0,
          onClick: handleClick,
          onKeyUp: onKeyUpHandler,
          href: disabled ? void 0 : href,
          target: newWindow ? "_blank" : void 0,
          rel: newWindow ? "noreferrer" : void 0,
          ...others,
          children: buttonContent
        }
      );
    }
    return /* @__PURE__ */ jsx(
      "button",
      {
        ref,
        className: classes,
        disabled,
        type: htmlType,
        onClick: handleClick,
        ...others,
        children: buttonContent
      }
    );
  }
);
Button.displayName = "Button";
var Button_default = Button;
export {
  Button_default as default
};
